declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}

export function trackRegisterClick(label?: string) {
  window.gtag?.("event", "register_click", {
    event_category: "conversion",
    ...(label ? { event_label: label } : {}),
  });
}
